import { Edit } from "@mui/icons-material";
import { TextField } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { DocumentDetailContext } from "../contexts/DocumentDetailContext";

const DocumentDescription = (props) => {
    const { data = {}, setDocumentData, duplicateDocumentView, setDataSave, isDarkMode } = useContext(DocumentDetailContext);
    const [documentDescription, setDocumentDescription] = useState("");
    const [showTextbox, setTextbox] = useState(true);

    useEffect(() => {
        setDocumentDescription(data?.Entity_Details?.doc_description)
    }, [data?.Entity_Details?.doc_description])

    const handleChange = (e) => {
        let { value = "" } = e.target || {};
        if (value.length <= 50) {
            let temp = { ...data };
            temp.Entity_Details.doc_description = value;
            setDocumentData({ ...temp });
            setDocumentDescription(value);
            setDataSave(true);
        }
    }

    // const handleEditIcon = () => {
    //     setTextbox(true)
    // }

    return <div className="doc-desc-section">
        <div className="icon-text">
            <div className="notes-label">Document Description</div>
            {/* {!duplicateDocumentView && <Edit
                style={{
                    color: "var(--hti-magenta)",
                    marginLeft: "5px"
                }}
                fontSize="small"
                onClick={() => !duplicateDocumentView && handleEditIcon()} />} */}
        </div>
        <>
            <TextField
                name="doc_desc"
                value={documentDescription || ""}
                onChange={handleChange}
                id="outlined-textarea"
                rows={1}
                multiline
                disabled={duplicateDocumentView}
                // onBlur={() => setTextbox(false)}
                sx={{
                    width: "100%",
                    marginTop: "15px",
                    "> div": {
                        padding: "5px 10px",
                        color: "var(--text-primary)"
                    },
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            border: "1px solid var(--border-dark)"
                        },
                        '&:hover fieldset': {
                            border: isDarkMode ? "1px solid var(--border-dark)" : '1px solid var(--hti-purple-70)',
                            boxShadow: "0 4px 4px #0000000d"
                        },
                        '&.Mui-focused fieldset': {
                            border: isDarkMode ? "1px solid var(--border-dark)" : '1px solid var(--hti-purple-70) !important',
                        },
                    },

                }}
                InputProps={{
                    inputProps: {
                        maxLength: 50,
                    },
                }}
            />
            <div className="grey-txt" style={{ color: "#a2a0a0" }}> Maximum {documentDescription?.length ? documentDescription?.length + " / " : ""}50 characters.</div>
        </>
    </div>
}

export default DocumentDescription;